import {FormattedMessage, FormattedNumber} from "react-intl";
import React from "react";

export const FM = (id, defaultMessage) => <FormattedMessage id={id} defaultMessage={defaultMessage}/>;
// eslint-disable-next-line
export const FN = (value) => <FormattedNumber value={value} style="currency" currency="CAD"/>;